module.exports = __webpack_public_path__ + "img/pjysc1.2ec83beb.png";